
import Image from "next/image"

import Header from "../components/header";
import Skill from "../components/skill"

export default function content({ modalHandler }) {

  return (
    <div>
    
      <div className="flex flex-col pt-8 text-2xl text-white leading-loose border bc-foreground w-full">

        <div className="mx-8">
          <Header
            text={ "Languages"}
            modal={ "languages" }
            modalHandler={ modalHandler }>
          </Header>
        </div>

        <div className="flex flex-row flex-wrap my-6 px-4">

          <Skill 
            name="php" 
            svgPath="svgs/php.svg" 
            label="PHP Logo" 
            bgColour="#8892bf"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="javascript" 
            svgPath="svgs/javascript.svg" 
            label="JavaScript Logo" 
            bgColour="#F7DF1E"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="dart" 
            svgPath="svgs/dart.svg" 
            label="Dart Logo" 
            bgColour="#0175C2"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="csharp" 
            svgPath="svgs/csharp.svg" 
            label="C# Logo" 
            bgColour="#239120"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="python" 
            svgPath="svgs/python.svg" 
            label="Python Logo" 
            bgColour="#3776AB"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="java" 
            svgPath="svgs/java.svg" 
            label="Java Logo" 
            bgColour="#EB6D00"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="vb" 
            svgPath="svgs/vb.svg" 
            label="VB Logo" 
            bgColour="#1A6098"
            padding="p-3"
            modalHandler={ modalHandler }>
          </Skill>

        </div>

      </div>


      <div className="flex flex-col pt-8 mt-8 text-2xl text-white leading-loose border bc-foreground w-full">

        <div className="mx-8">
          <Header
            text={ "Frameworks"}
            modal={ "frameworks" }
            modalHandler={ modalHandler }>
          </Header>
        </div>

        <div className="flex flex-row flex-wrap my-6 px-4">

          <Skill 
            name="wordpress" 
            svgPath="svgs/wordpress.svg" 
            label="WordPress Logo" 
            bgColour="#1F6F93"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="zendframework" 
            svgPath="svgs/zendframework.svg" 
            label="Zend/Laminas Logo" 
            bgColour="#68B604"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="flutter" 
            svgPath="svgs/flutter.svg" 
            label="Flutter Logo" 
            bgColour="#60C9F8"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="nextjs" 
            svgPath="svgs/nextjs.svg" 
            label="Next.js Logo" 
            bgColour="#131313"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="dotnet" 
            svgPath="svgs/dotnet.svg" 
            label=".Net Logo" 
            bgColour="#512BD4"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="godotengine" 
            svgPath="svgs/godotengine.svg" 
            label="Godot Logo" 
            bgColour="#478CBF"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="spring" 
            svgPath="svgs/spring.svg" 
            label="Spring Logo" 
            bgColour="#6DB33F"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

        </div>

      </div>


      <div className="flex flex-col pt-8 mt-8 text-2xl text-white leading-loose border bc-foreground w-full">

        <div className="mx-8">
          <Header
            text={ "Tools"}
            modal={ "tools" }
            modalHandler={ modalHandler }>
          </Header>
        </div>

        <div className="flex flex-row flex-wrap my-6 px-4">

          <Skill 
            name="mysql" 
            svgPath="svgs/mysql.svg" 
            label="MySQL Logo" 
            bgColour="#4479A1"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="reactjs" 
            svgPath="svgs/reactjs.svg" 
            label="ReactJS Logo" 
            bgColour="#00D8FF"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="tailwind" 
            svgPath="svgs/tailwind.svg" 
            label="Tailwind Logo" 
            bgColour="#38BDF8"
            padding="p-4"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="git" 
            svgPath="svgs/git.svg" 
            label="Git Logo" 
            bgColour="#F05032"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="github" 
            svgPath="svgs/github.svg" 
            label="GitHub Logo" 
            bgColour="#181717"
            padding="p-2"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="gitlab" 
            svgPath="svgs/gitlab.svg" 
            label="GitLab Logo" 
            bgColour="#FC6D26"
            padding="p-3"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="nodejs" 
            svgPath="svgs/nodejs.svg" 
            label="NodeJS Logo" 
            bgColour="#83CD29"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="wamp" 
            svgPath="svgs/wamp.svg" 
            label="WAMP Logo" 
            bgColour="#FF0099"
            padding="p-1"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="intellijidea" 
            svgPath="svgs/intellijidea.svg" 
            label="IntelliJ Idea Logo" 
            bgColour="#FD3F47"
            padding="p-3"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="visualstudiocode" 
            svgPath="svgs/visualstudiocode.svg" 
            label="VS Code Logo" 
            bgColour="#007ACC"
            padding="p-3"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="visualstudio" 
            svgPath="svgs/visualstudio.svg" 
            label="Visual Studio Logo" 
            bgColour="#5C2D91"
            padding="p-3"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="putty" 
            svgPath="svgs/putty.svg" 
            label="Putty Logo" 
            bgColour="#FED11E"
            padding="p-3"
            modalHandler={ modalHandler }>
          </Skill>

          <Skill 
            name="winscp" 
            svgPath="svgs/winscp.svg" 
            label="WinSCP Logo" 
            bgColour="#474B4F"
            padding="p-1"
            modalHandler={ modalHandler }>
          </Skill>

        </div>

      </div>

    </div>
  )
}